import { Setting } from 'types/back-office-settings';
import type { SettingSectionLayout } from '../settingLayout';

/** The "Colleagues, lists, notifications and module options" section: its group bands and their rows, in page order. */
export const COLLEAGUES_SECTION: SettingSectionLayout = {
    anchor: 'colleagues',
    groups: [{ id: 'colleagues-personal-data', rows: [{ key: Setting.OBFUSCATE_EMPLOYEE_PERSONAL_ID_CODE }] }],
};
